<ng-container [ngSwitch]="buttonState">
    <!-- Booked with partner -->
    <ng-container *ngSwitchCase="'bookedMatched'">
        <div class="w-full flex justify-between gap-1">
            <div
                class="relative w-[calc(100%_-_28px)] flex justify-center items-center !pl-2 !pr-2 !py-0 !h-10 bg-[#E8DCCD] rounded-lg overflow-hidden">
                <div class="h-full min-w-1 bg-blurple absolute top-0 left-0"></div>
                <div class="w-full flex flex-row justify-start items-center">
                    <fm-avatar
                        [avatarLocation]="profilePhoto"
                        [isSaved]="saved"
                        size="sm"></fm-avatar>
                    <div
                        class="flex-1 flex justify-center items-center text-12 leading-[normal] font-medium font-inter min-w-0 ml-1">
                        <div class="block truncate text-color">
                            <fa-icon
                                matTooltip="{{
                                    displayName
                                }} will be your partner for this session unless one of you cancels"
                                matTooltipPosition="above"
                                matTooltipShowDelay="200"
                                matTooltipClass="f-tooltip"
                                *ngIf="isLockedIn"
                                class="text-12 leading-[normal]"
                                [icon]="faLock"></fa-icon>
                            {{ displayName }}</div
                        >
                    </div>
                    @if (!dynamicPanel && activityIcon) {
                        <div class="rounded-lg h-[15px] w-[15px] border border-[#E8DCCD] flex">
                            <fa-icon class="text-[12.25px]" [icon]="activityIcon" />
                        </div>
                    }
                </div>
            </div>
            <fm-actions-menu-availability-list
                [sessionExternalId]="externalId"
                [targetUserProfileUrl]="profileSlug"
                [sharedAvailability]="false"
                [saved]="false"
                [activityType]="sessionActivityType"
                [quietMode]="partnerQuietMode"
                (cancelSessionSelected)="onCancelSessionSelected($event)" />
        </div>
    </ng-container>

    <ng-container *ngSwitchCase="'confirmCancel'">
        <div
            class="flex flex-row items-center justify-center w-full h-10 rounded-fm-5 shadow-fm-availability-item border-2 border-[#E8DCCD] overflow-hidden gap-[3px] px-[3px]">
            <p-button
                size="small"
                class="flex-1"
                styleClass="w-full"
                severity="danger"
                [loading]="cancelInProgress"
                (click)="onCancelConfirmed()"
                label="Cancel" />

            <p-button
                size="small"
                severity="info"
                class="flex-1"
                styleClass="w-full"
                [disabled]="cancelInProgress"
                (click)="onKeepSession($event)"
                label="Keep" />
        </div>
    </ng-container>
    <!-- Available session -->
    <ng-container *ngSwitchCase="'available'">
        <div class="w-full flex justify-between gap-1">
            @if (!selected) {
                <p-button
                    (click)="selectSession($event)"
                    [disabled]="disable"
                    size="large"
                    severity="secondary"
                    class="overflow-hidden flex-1"
                    styleClass="w-full !pl-[3px] !pr-2 !py-0 !h-10">
                    <div class="w-full flex flex-row justify-start items-center">
                        <div
                            class="flex-1 flex justify-center items-center text-12 leading-[normal] font-medium font-inter min-w-0 ml-1">
                            <div class="block truncate">{{ sessionTimeLabel }}</div>
                        </div>
                        @if (partnerQuietMode) {
                            <div
                                class="rounded-lg h-[15px] w-[15px] bg-[#D6D7F4] border border-[#D6D7F4] flex mr-1">
                                <fa-icon
                                    class="text-[12.25px] text-primary"
                                    [icon]="faMicrophoneSlash" />
                            </div>
                        }
                        @if (activityIcon) {
                            <div class="rounded-lg h-[15px] w-[15px] border border-[#E8DCCD] flex">
                                <fa-icon class="text-[12.25px] text-color" [icon]="activityIcon" />
                            </div>
                        }
                    </div>
                </p-button>
            } @else {
                <p-button
                    (click)="bookSession($event)"
                    size="large"
                    severity="primary"
                    class="overflow-hidden flex-1"
                    styleClass="w-full !pl-[3px] !pr-2 !py-0 !h-10"
                    [label]="'Book ' + sessionTimeLabel"
                    icon="pi pi-lock" />
            }
        </div>
    </ng-container>
</ng-container>
